// extracted by mini-css-extract-plugin
module.exports = {"form":"contactform-module--form--2ubhA","button":"contactform-module--button--1HkjG","link":"contactform-module--link--DA__R"};